import { z } from 'zod';

export const germanErrorMap: z.ZodErrorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === z.ZodParsedType.undefined) {
        message = 'Darf nicht leer sein';
      } else {
        message = `${types[issue.expected]} erwartet, ${
          types[issue.received]
        } erhalten`;
      }
      break;
    case z.ZodIssueCode.invalid_literal:
      message = `Ungültiger Literalwert, ${JSON.stringify(
        issue.expected,
        z.util.jsonStringifyReplacer,
      )} erwartet`;
      break;
    case z.ZodIssueCode.unrecognized_keys:
      message = `Unbekannte Schlüssel im Objekt: ${z.util.joinValues(
        issue.keys,
        ', ',
      )}`;
      break;
    case z.ZodIssueCode.invalid_union:
      message = `Ungültige Eingabe`;
      break;
    case z.ZodIssueCode.invalid_union_discriminator:
      message = `Ungültiger Diskriminatorwert. ${z.util.joinValues(
        issue.options,
      )} erwartet`;
      break;
    case z.ZodIssueCode.invalid_enum_value:
      message = `Ungültiger Enum-Wert. ${z.util.joinValues(
        issue.options,
      )} erwartet, '${issue.received} erhalten'`;
      break;
    case z.ZodIssueCode.invalid_arguments:
      message = `Ungültige Funktionsargumente`;
      break;
    case z.ZodIssueCode.invalid_return_type:
      message = `Ungültiger Funktionsrückgabewert`;
      break;
    case z.ZodIssueCode.invalid_date:
      message = `Ungültiges Datum`;
      break;
    case z.ZodIssueCode.invalid_string:
      if (typeof issue.validation === 'object') {
        if ('includes' in issue.validation) {
          message = `Ungültige Eingabe: muss "${issue.validation.includes}" enthalten`;
          if (typeof issue.validation.position === 'number') {
            message = `${message} an einer oder mehreren Positionen größer oder gleich ${issue.validation.position}`;
          }
        } else if ('startsWith' in issue.validation) {
          message = `Ungültige Eingabe: muss mit "${issue.validation.startsWith}" beginnen`;
        } else if ('endsWith' in issue.validation) {
          message = `Ungültige Eingabe: muss mit "${issue.validation.endsWith}" enden`;
        } else {
          z.util.assertNever(issue.validation);
        }
      } else if (issue.validation !== 'regex') {
        message = `Ungültige ${issue.validation}`;
      } else {
        message = 'Ungültig';
      }
      break;
    case z.ZodIssueCode.too_small:
      if (issue.type === 'array')
        message = `Array muss ${
          issue.exact ? 'genau' : issue.inclusive ? `mindestens` : `mehr als`
        } ${issue.minimum} Element(e) enthalten`;
      else if (issue.type === 'string')
        message = `String muss ${
          issue.exact ? 'genau' : issue.inclusive ? `mindestens` : `mehr als`
        } ${issue.minimum} Zeichen enthalten`;
      else if (issue.type === 'number')
        message = `Zahl muss ${
          issue.exact
            ? `genau `
            : issue.inclusive
              ? `größer oder gleich `
              : `größer als `
        }${issue.minimum} sein`;
      else if (issue.type === 'date')
        message = `Datum muss ${
          issue.exact
            ? `genau  `
            : issue.inclusive
              ? `größer oder gleich `
              : `größer als `
        }${new Date(Number(issue.minimum))} sein`;
      else message = 'Ungültige Eingabe';
      break;
    case z.ZodIssueCode.too_big:
      if (issue.type === 'array')
        message = `Array ${
          issue.exact
            ? `muss genau`
            : issue.inclusive
              ? `darf höchstens`
              : `muss weniger als`
        } ${issue.maximum} Element(e) enthalten`;
      else if (issue.type === 'string')
        message = `String ${
          issue.exact
            ? `muss genau`
            : issue.inclusive
              ? `darf höchstens`
              : `muss weniger als`
        } ${issue.maximum} Zeichen enthalten`;
      else if (issue.type === 'number')
        message = `Zahl muss ${
          issue.exact
            ? `genau`
            : issue.inclusive
              ? `kleiner oder gleich`
              : `kleiner als`
        } ${issue.maximum} sein`;
      else if (issue.type === 'bigint')
        message = `Zahl muss ${
          issue.exact
            ? `genau`
            : issue.inclusive
              ? `kleiner oder gleich`
              : `kleiner als`
        } ${issue.maximum} sein`;
      else if (issue.type === 'date')
        message = `Datum muss ${
          issue.exact
            ? `genau`
            : issue.inclusive
              ? `kleiner oder gleich`
              : `kleiner als`
        } ${new Date(Number(issue.maximum))} sein`;
      else message = 'Ungültige Eingabe';
      break;
    case z.ZodIssueCode.custom:
      message = `Ungültige Eingabe`;
      break;
    case z.ZodIssueCode.invalid_intersection_types:
      message = `Schnittmengenergebnisse konnten nicht zusammengeführt werden`;
      break;
    case z.ZodIssueCode.not_multiple_of:
      message = `Zahl muss ein Vielfaches von ${issue.multipleOf} sein`;
      break;
    case z.ZodIssueCode.not_finite:
      message = 'Zahl muss endlich sein';
      break;
    default:
      message = _ctx.defaultError;
      z.util.assertNever(issue);
  }
  return { message };
};

const types = {
  function: 'Funktion',
  number: 'Zahl',
  string: 'String',
  nan: 'NaN',
  integer: 'Ganzzahl',
  float: 'Gleitkommazahl',
  boolean: 'Boolean',
  date: 'Datum',
  bigint: 'Bigint',
  undefined: 'Undefined',
  symbol: 'Symbol',
  null: 'Nullwert',
  array: 'Array',
  object: 'Objekt',
  unknown: 'Unbekannt',
  promise: 'Promise',
  void: 'Leer',
  never: 'Nie',
  map: 'Map',
  set: 'Set',
};
